import { z } from 'zod';
import { ApprovalSchema } from '../../entities/approval';
/**
 * Get Approval
 * GET /api/v2/approval/:id — for the requester, the reviewers and admins.
 * `canDecide` / `canOverride` / `canWithdraw` tell the card which actions the
 * caller has, so the client never repeats the rules.
 */ export const GetApprovalResponseSchema = z.object({
    approval: ApprovalSchema,
    canDecide: z.boolean(),
    canOverride: z.boolean(),
    canWithdraw: z.boolean()
});

//# sourceMappingURL=get-approval.schema.js.map